import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en';
import ru from './ru';

let resources = { en, ru };

import { lctran } from '../app/components/LongevityCalculator/LongevityCalculator-translations';
Object.assign(resources.en.translation,lctran.en.translation);
Object.assign(resources.ru.translation,lctran.ru.translation);

export function detectLanguage(settings={})
{
	if (settings?.lang) return settings.lang;

	const localLang = localStorage.getItem('lang');
	if (localLang) return localLang;

	return 'ru';
	return navigator.language.startsWith('en') ? 'en' : 'ru';
}


i18n
    .use(initReactI18next)
    .init({
        resources,

        lng: detectLanguage(),

        fallbackLng: false,

        interpolation: {
            escapeValue: false,
        },

        react: {
            useSuspense: false,
        },

        // optional but useful if you rely on plural suffixes like _one/_few
        pluralSeparator: '_',
    });

export default i18n;
